import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toPropertyKey from "/usr/app/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["cash_price"],
  _excluded2 = ["cash_price"],
  _excluded3 = ["down_payment"],
  _excluded4 = ["down_payment"],
  _excluded5 = ["last_payment"],
  _excluded6 = ["last_payment"];
import React from "react";
var __jsx = React.createElement;
/** ------- Imports Dependencies ------- */
import { useTranslation } from "@i18n";
import { useInstallmentCalculator } from "@/_MiniApps/Installment-calculator/InstallmentCalculatorContext";
import { useState } from "react";
import useBoolean from "@hooks/useBoolean";
import { formatNumberWithCommas, getArabicYearWord } from "@/utils/stringHelpers";
import Input from "@/components/UiKit/Input/Input";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import InstallmentCalculatorTerms from "@/_MiniApps/Installment-calculator/InstallmentCalculatorTerms";

/** ------- Import Styles ------- */
import stl from "../styles/InstallmentCalculatorLanding.module.css";
import useHelpers from "@hooks/useHelpers";

/** ------- Type Declarations ------- */

/** ------- Component ------- */

var InstallmentCalculatorLanding = function InstallmentCalculatorLanding(_ref) {
  var _state$cash_price, _state$down_payment, _state$last_payment;
  var onChangeCashPrice = _ref.onChangeCashPrice,
    cashPrice = _ref.cashPrice;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useInstallmentCalcul = useInstallmentCalculator(),
    state = _useInstallmentCalcul.state,
    setState = _useInstallmentCalcul.setState;
  var _useState = useState({}),
    errors = _useState[0],
    updateErrors = _useState[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useBoolean = useBoolean(),
    isCalculatorOpen = _useBoolean.value,
    openCalculator = _useBoolean.setTrue,
    closeCalculator = _useBoolean.setFalse;
  var _useState2 = useState(false),
    hasInteracted = _useState2[0],
    setHasInteracted = _useState2[1];
  // get post id from params
  var handleInputChange = function handleInputChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

    // Allow numbers and commas, and strip out invalid characters
    var numericValue = value.replace(/[^0-9,]/g, '');

    // Check if the input is valid and parse it
    var parsedValue = parseFloat(numericValue.replace(/,/g, '')); // Remove commas for parsing

    // Validate empty and negative values
    if (numericValue === '' || parsedValue < 0) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, 0));
      });
      return;
    }
    handleFirstInteraction({
      field: name === 'down_payment' ? 'first_payment' : name
    });
    if (name === 'down_payment' && parsedValue > state.max_down_payment || name === 'last_payment' && parsedValue > state.max_last_payment) {
      updateErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, t("\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0623\u0648\u0644\u0649  ".concat(state.max_down_payment, "  \u0631\u064A\u0627\u0644"), {
        ns: 'web_common'
      }))));
      return;
    } else {
      if (name === 'cash_price') {
        onChangeCashPrice(parsedValue);
        return;
      }
      // Clear the error if the value is valid
      var _ = errors[name],
        rest = _objectWithoutProperties(errors, [name].map(_toPropertyKey));
      updateErrors(rest);
    }
    // Only update state if the value is valid
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, parsedValue));
    });
  };
  var handleYearChange = function handleYearChange(year) {
    handleFirstInteraction({
      field: 'financing_period'
    });
    setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        period: year * 12
      });
    });
  };
  var handleFirstInteraction = function handleFirstInteraction(_ref2) {
    var field = _ref2.field;
    if (!hasInteracted) {
      setHasInteracted(true);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: [stl.calculatorViewContainer].join(" ")
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.CalculatorBox
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.firstSection
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_search"
    }),
    className: [stl.formStyle, errors.cash_price ? stl.inputError : ""].join(" "),
    name: "cash_price",
    min: 0,
    label: t("suggested_car_price", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.cash_price) {
        var cash_price = errors.cash_price,
          rest = _objectWithoutProperties(errors, _excluded);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.cash_price) {
        var cash_price = errors.cash_price,
          rest = _objectWithoutProperties(errors, _excluded2);
        updateErrors(rest);
      }
    }
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$cash_price = state.cash_price) !== null && _state$cash_price !== void 0 ? _state$cash_price : 0)
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.financePeriodTitle
  }, t('financing_duration_years', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodYearsBox
  }, Array.from({
    length: state.years
  }, function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: [stl.financePeriodYear, state.period / 12 === i + 1 ? stl.financePeriodYearActive : ''].join(' '),
      key: "financePeriodYear-".concat(i),
      onClick: function onClick() {
        return handleYearChange(i + 1);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearValue
    }, i + 1), /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearUnit
    }, getArabicYearWord(i + 1, t)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_search"
    }),
    className: [stl.formStyle, errors.down_payment ? stl.inputError : ""].join(" "),
    name: "down_payment",
    label: t("down_payment_2", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded3);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded4);
        updateErrors(rest);
      }
    },
    min: 0,
    max: 7500
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$down_payment = state.down_payment) !== null && _state$down_payment !== void 0 ? _state$down_payment : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.down_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, errors.down_payment ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("validation_down_payment_exceed", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state.max_down_payment), " "), /*#__PURE__*/React.createElement("span", null, t('sar', {
    ns: "web_search"
  }))) : ""))), /*#__PURE__*/React.createElement("div", {
    className: stl.inputsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_search"
    }),
    className: [stl.formStyle, errors.last_payment ? stl.inputError : ""].join(" "),
    name: "last_payment",
    min: 0,
    max: 7500,
    label: t("last_payment_2", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded5);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded6);
        updateErrors(rest);
      }
    }
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$last_payment = state.last_payment) !== null && _state$last_payment !== void 0 ? _state$last_payment : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.last_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, errors.last_payment ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("validation_final_payment_exceed", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state.max_last_payment), " "), /*#__PURE__*/React.createElement("span", null, t('sar', {
    ns: "web_search"
  }))) : null))))), /*#__PURE__*/React.createElement("div", {
    className: stl.secondSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.secondSectionBox
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.monthlyPaymentBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxTitle
  }, t('monthly_payment', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentValueBox
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.monthlyPaymentPrice
  }, formatNumberWithCommas(state.monthly_installment < 0 ? 0 : state.monthly_installment)), /*#__PURE__*/React.createElement("span", {
    className: stl.monthlyPriceUnit
  }, t("sar", {
    ns: "web_search"
  }), " /", " ", t("monthly", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxNote
  }, t("provided_price_estimate_based_information", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.similarCtaWrapper
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl('/filters', {
      transaction_type_id: 2,
      car_shape_id: [2, 4, 5, 3, 7, 6],
      sort: 'sellingprice',
      sellingprice_from: parseInt(cashPrice) - 10000,
      sellingprice_to: parseInt(cashPrice) + 10000
    }),
    className: stl.similarCta
  }, t("cars_within_payment_range", {
    ns: "web_checkout_finance"
  }))))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: isCalculatorOpen,
    onClose: closeCalculator
  }, /*#__PURE__*/React.createElement(InstallmentCalculatorTerms, null)));
};
export default InstallmentCalculatorLanding;